export const approvalTypeLabel = [
    "휴가", // 0
]

export const statusLabels = [
    "재직중",
    "휴직",
    '퇴사',
]